import * as React from "react";
import { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { graphTypes, subscriptionTiers } from "../../../../Config/constants";
import { ChevronDown } from "lucide-react";
import ProjectionsDialog from "../../../Shared/layout/ProjectionsDialog.jsx";
import TabSelector from "../../../Shared/ui/TabSelector.jsx";
import Tab from "../../../Shared/ui/Tab.jsx";
import { dataService } from "../../../../Services/data/data.service.js";

export default function GraphTabs({ accountCategories, handleSetActiveProjection, activeProjection, ...props }) {
  const classes = useStyles();
  const dropdownRef = useRef(null);
  const dropdownButtonRef = useRef(null);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [subscriptionTier, setSubscriptionTier] = useState(null);

  useEffect(() => {
    // Fetch the subscription tier from the data service
    dataService
      .getSubscriptionTierByUserId(props.Login.userid)
      .then((response) => {
        if (response && response.success) {
          setSubscriptionTier(response.subscriptionTier);
        } else if (response && !response.success) {
          console.error(response.errorMessage);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleToggle = () => {
    setDropdownOpen((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target) && dropdownButtonRef.current && !dropdownButtonRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDropdownSelection = (graphType) => {
    props.handleGraphTypeSelection(graphType);
    setDropdownOpen(false);
  };

  return (
    <>
      <div className={classes.toggleFilterContainer}>
        <TabSelector value={props.selectedGraphType} onChange={props.handleGraphTypeSelection}>
          <Tab value={graphTypes.OUTPUT} style={{ width: "7.5rem" }}>
            Output
          </Tab>
          <Tab value={graphTypes.YAMAZUMI} style={{ width: "7.5rem" }}>
            Yamazumi
          </Tab>
          <Tab value={graphTypes.TIMELINE} style={{ width: "7.5rem" }}>
            Timeline
          </Tab>
          {/* <Tab value={graphTypes.FINANCIAL} style={{ width: "7.5rem" }}>
            Financial
          </Tab> */}
          <Tab value={graphTypes.PROFITLOSS} style={{ width: "7.5rem" }}>
            Profit & Loss
          </Tab>
        </TabSelector>
        {/* Projections */}
        {subscriptionTier !== null && subscriptionTier.id !== subscriptionTiers.TRYOUT && (
          <ProjectionsDialog accountCategories={accountCategories} activeProjection={activeProjection} handleSetActiveProjection={handleSetActiveProjection} />
        )}
      </div>

      <div className={classes.tabDropdown}>
        <button ref={dropdownButtonRef} className={classes.tabDropdown__button} onClick={() => handleToggle()}>
          {props.selectedGraphType === graphTypes.OUTPUT
            ? "Output"
            : props.selectedGraphType === graphTypes.YAMAZUMI
            ? "Yamazumi"
            : props.selectedGraphType === graphTypes.TIMELINE
            ? "Timeline"
            : props.selectedGraphType === graphTypes.FINANCIAL
            ? "Financial"
            : "Profit & Loss"}
          <ChevronDown className={classes.button__icon} style={{ transform: dropdownOpen ? "rotate(180deg)" : "rotate(0deg)" }} />
        </button>
        {dropdownOpen && (
          <div ref={dropdownRef} className={classes.tabDropdown__dropdownContainer}>
            <button onClick={() => handleDropdownSelection(graphTypes.OUTPUT)} className={classes.tabDropdown__optionButton}>
              <p className={classes.tabDropdown__label} style={{ color: props.selectedGraphType === graphTypes.OUTPUT ? "#C3996B" : "#0C0E29" }}>
                Output
              </p>
            </button>
            <button onClick={() => handleDropdownSelection(graphTypes.YAMAZUMI)} className={classes.tabDropdown__optionButton}>
              <p className={classes.tabDropdown__label} style={{ color: props.selectedGraphType === graphTypes.YAMAZUMI ? "#C3996B" : "#0C0E29" }}>
                Yamazumi
              </p>
            </button>
            <button onClick={() => handleDropdownSelection(graphTypes.TIMELINE)} className={classes.tabDropdown__optionButton}>
              <p className={classes.tabDropdown__label} style={{ color: props.selectedGraphType === graphTypes.TIMELINE ? "#C3996B" : "#0C0E29" }}>
                Timeline
              </p>
            </button>
            {/* <button onClick={() => handleDropdownSelection(graphTypes.FINANCIAL)} className={classes.tabDropdown__optionButton}>
              <p className={classes.tabDropdown__label} style={{ color: props.selectedGraphType === graphTypes.FINANCIAL ? "#C3996B" : "#0C0E29" }}>
                Financial
              </p>
            </button> */}
            <button onClick={() => handleDropdownSelection(graphTypes.PROFITLOSS)} className={classes.tabDropdown__optionButton}>
              <p className={classes.tabDropdown__label} style={{ color: props.selectedGraphType === graphTypes.PROFITLOSS ? "#C3996B" : "#0C0E29" }}>
                Profit & Loss
              </p>
            </button>
          </div>
        )}
        {subscriptionTier !== null && subscriptionTier.id !== subscriptionTiers.TRYOUT && (
          <ProjectionsDialog accountCategories={accountCategories} activeProjection={activeProjection} mobileAlignment={"right"} handleSetActiveProjection={handleSetActiveProjection} />
        )}
      </div>
    </>
  );
}
const useStyles = makeStyles((theme) => ({
  toggleFilterContainer: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 999,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",

    [theme.breakpoints.down("md")]: {
      // don't show on mobile
      display: "none",
    },
  },

  toggleFilter: {
    height: "32px",
    boxSizing: "border-box",

    display: "flex",
    alignItems: "center",

    backgroundColor: "#DCDCDC",
    borderRadius: "4px",

    padding: "1px",
  },

  toggleFilter__optionButton: {
    height: "100%",
    width: "128px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",

    border: "none",
    borderRadius: "3px",

    color: "#0C0E29",
    backgroundColor: "transparent",

    transition: "all ease-in-out 0.2s",

    zIndex: "1",

    "&:hover": {
      // backgroundColor: "#DCDCDC",
      cursor: "pointer",
    },

    [theme.breakpoints.down("xs")]: {
      width: "96px",
    },
  },

  toggleFilter__label: {
    fontFamily: "Lato, sans-serif",
    fontSize: "14px",
    margin: "0",
  },

  toggleSelected: {
    width: "calc(100% / 5)",
    height: "30px",
    position: "absolute",
    transition: "transform 0.2s",

    backgroundColor: "white",
    borderRadius: "3px",
  },

  tabDropdown: {
    position: "relative",
    display: "none",
    [theme.breakpoints.down("md")]: {
      width: "100%",

      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: ".5rem",
    },
  },

  tabDropdown__button: {
    height: "36px",
    minWidth: "200px",

    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "6px",

    padding: "8px",
    paddingLeft: "12px",
    backgroundColor: "#FFFFFF",
    borderRadius: "4px",
    border: "1px solid #EDEDED",

    color: "#0C0E29",
    fontFamily: "Lato, sans-serif",
    fontSize: "16px",

    "&:hover": {
      cursor: "pointer",
    },
  },

  button__icon: {
    width: "20px",
    height: "20px",

    color: "#0C0E29",
    strokeWidth: "1.4px",
  },

  tabDropdown__dropdownContainer: {
    position: "absolute",
    top: "calc(100% + 6px)",
    left: "0",
    width: "fit-content",
    backgroundColor: "#FFFFFF",
    borderRadius: "6px",
    border: "none",
    zIndex: "999",

    padding: "4px",

    boxShadow: "2px 4px 12px 0px rgba(175, 175, 175, 0.4)",
  },

  tabDropdown__optionButton: {
    height: "36px",
    width: "100%",
    padding: "8px 12px",
    backgroundColor: "transparent",
    border: "none",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#F8F8F8",
    },
  },

  tabDropdown__label: {
    fontFamily: "Lato, sans-serif",
    fontSize: "16px",
    color: "#0C0E29",
    margin: "0",
  },
}));
